// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Optional: If you want the language to be auto-detected from the browser
// import LanguageDetector from 'i18next-browser-languagedetector';

// Example: Your translation resources, imported or inline
import en from './locales/en.json';
import de from './locales/de.json';
import ro from './locales/ro.json';
import ar from './locales/ar.json';

i18n
    // .use(LanguageDetector) // If you want to use browser language detection, uncomment this line and install i18next-browser-languagedetector.
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            de: { translation: de },
            ro: { translation: ro },
            ar: { translation: ar },
        },
        // Initial language to use
        lng: 'en',
        // If language not found, fall back to this
        fallbackLng: 'en',
        // React already does safe string escaping
        interpolation: {
            escapeValue: false,
        },
        debug: false, // Set to true to see debugging info in console
    });

export default i18n;
